import { BASE_URL_API } from "../../../constants";
import { useAuthStore } from "../../../stores/useAuthStore";
import fetcher from "../../../utils/fetcher";

export const _api_get_document_data = ({ fid, document_type = "hr" }) => {
    const url = `${BASE_URL_API}/documents/${document_type}/files/document/${fid}`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_delete_document = ({ document_id }) => {
    const url = `${BASE_URL_API}/documents/hr/files/document/${document_id}/delete`;
    return fetcher(url, {
        method: "DELETE",
        credentials: "include",
    });
};

export const downloadFile = async ({ document_id, document_type = "hr" }) => {
    const user = useAuthStore.getState().infos;
    try {
        const response = await fetch(
            `${BASE_URL_API}/documents/${document_type}/files/document/${document_id}/download`,
            {
                headers: {
                    Authorization: `Bearer ${user?.access}`,
                },
                method: "GET",
                credentials: "include",
            }
        );

        if (!response.ok) {
            throw new Error("Response not OK");
        }

        const contentDisposition = response.headers.get("Content-Disposition");

        // Extract filename from Content-Disposition header
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        let filename = "user_format_export.xlsx"; // Default filename
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
        }

        const blob = await response.blob();

        let a = document.createElement("a");
        if (window.URL && window.URL.createObjectURL) {
            let objectUrl = window.URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(objectUrl);
            return {
                success: true,
            };
        } else {
            // Fallback for browsers that do not support createObjectURL
            return {
                success: false,
                message: "Your browser does not support this feature.",
            };
        }
    } catch (error) {
        console.error("Error fetching or processing data:", error);
        // Handle error as needed
        return {
            success: false,
            message: error,
        };
    }
};
